module.exports = {
    SEARCH_GET: 'SEARCH_GET',
};
